// extracted by mini-css-extract-plugin
export default {"image":"KW-z","loaded":"LW-z"};